import React, { useState } from "react";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";

interface NavbarProps {
  days: string[];
  onAddDay: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ days, onAddDay }) => {
  const [state, setState] = useState({
    left: false,
    right: false,
    top: false,
    bottom: false,
  });

  const toggleDrawer =
    (anchor: keyof typeof state, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (event.type === "keydown") {
        return;
      }
      setState({ ...state, [anchor]: open });
    };

  const list = (anchor: string) => (
    <div className="text-black h-full flex flex-col space-y-4 px-4">
      <h2>{`${anchor}-hand sidebar`}</h2>
      <ul className="space-y-4">
        {days.map((day, index) => (
          <li key={index}>{day}</li>
        ))}
      </ul>
      <Button onClick={onAddDay}>+</Button>
    </div>
  );

  return (
    <div className="bg-white">
      {(["left", "right", "top", "bottom"] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, true)}>
            <div className="text-black ">{anchor}</div>
          </Button>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
};

export default Navbar;
